import { Button, Icon, Table, TableSelection, Tooltip } from 'AWS-UI-Components-React';
import React from 'react';
import { MapperPaginationSize } from '../../constants/constants';
import { deepClone, zip } from '../../utilities';
import logger from '../../utils/logging';
import { getJSClient } from '../js_client';
import { InfoLink } from './accuracy_benchmark_info';
import { Badges, Change, KeyOriginalMapping } from './mapper';

import MappingEditor from './mapping_editor';
import { Pagination } from './pagination';
import {
  ACCURACY_BENCHMARK_HELP_PANEL_COMPONENTS,
  CP_COLUMN_HELP_PANEL_COMPONENTS,
  getBenchmarkConfigDiffView,
  HCP_DRIVERS_ACCRUED_FA_DATA,
  HCP_DRIVERS_HEAD_CP_DATA,
  HELP_PANEL_INFOS,
  prepareListItem,
  toDisplayDate,
} from './utils';

export class MappingTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefinitions: [],
      subComponentMappingColumnDefinitions: [],
      componentMappingColumnDefinitions: [],
      subComponentRows: [],
      componentRows: [],
      loading: true,
      error: false,
      filters: props.filters,
      data: {},
      newMappingName: "",
      config: props.config,
      cognosConfig: props.cognosConfig,
      etlConfig: props.etlConfig,
      flashbackColumns: props.flashbackColumns,
      oWbrCpColumns: props.oWbrCpColumns,
      selectedMapping: {},
      selectedItems: [],
      selected: false,
      editInProgress: false,
      component: props.component,
      marketplace: props.marketplace,
      channel: props.channel,
      readOnly: props.readOnly,
      stagedMappings: [],
      disableRename: false,
      disableRenameOverride: true,
      benchmarkLists: {},
      filterBenchmarkLists: {},
      displayBenchmarkLists: {},
      initialDisplayList: true,
      subComponentEdit: false,
      ignoreDone: false,
      excludeDone: false,
      featureList: props.featureList,
    };
    this.cognosAccountMap = {};
    for (let cognos of props.cognosConfig) {
      this.cognosAccountMap[cognos.id] = {
        label: cognos.label,
        excluded: cognos.excluded || false,
        comment: cognos.comment || 'No comment',
      };
    }

    this.onCancellingEditModal = this.onCancellingEditModal.bind(this);
    this.onSubmitEditModal = this.onSubmitEditModal.bind(this);
    this.getCPDataSource = this.getCPDataSource.bind(this);
    this.getHCPDriver = this.getHCPDriver.bind(this);
    this.beginEdit = this.beginEdit.bind(this);
    this.beginAdd = this.beginAdd.bind(this);
    this.beginComponentEdit = this.beginComponentEdit.bind(this);
    this.onMappingPullSuccess = this.onMappingPullSuccess.bind(this);
    this.generateColumns = this.generateColumns.bind(this);
    this.getColumnDiffView = this.getColumnDiffView.bind(this);
    this.stageChange = props.stageChange.bind(this);
    this.unstageChange = props.unstageChange.bind(this);
  }

  componentWillMount = () => {
    this.client = getJSClient();
    this.getMappings();
  };

  onStagedMappingPullSuccess = (response) => {
    let stagedMappings = response.mappings;
    if (Array.isArray(stagedMappings)) {
      stagedMappings.sort(this.compare);
    } else {
      let array = [];
      for (let key in stagedMappings) {
        array.push(stagedMappings[key]);
      }
      array.sort(this.compare);
      stagedMappings = array;
    }
    this.setState({ stagedMappings: stagedMappings },
                  () => this.client.getMappings(this.onMappingPullSuccess, this.onMappingPullFailure, this.props.filters));
  };

  getMappings = () => {
    let stagingFilters = deepClone(this.props.filters);
    stagingFilters["version"] = "SA-" + this.props.stagingArea;
    this.client.getMappings(this.onStagedMappingPullSuccess, this.onMappingPullFailure, stagingFilters);
  };

  onMappingPullFailure = (response) => {
    logger.error(response);
    this.setState({ loading: false, error: true })
  };

  selectionChanged = (data) => {
    let items = data.detail.selectedItems;
    let mapping = {};
    if (items[0]) {
      mapping = this.state.data[items[0].subComponent];
    }
    this.setState({
      selected: items.length > 0,
      selectedMapping: mapping,
      selectedItems: items,
    });
  };

  flatten = (item) => {
    if (!item['subComponent']) {
      item['subComponent'] = item['component'];
    }
    let data = this.state.data;
    data[item['subComponent']] = item;
    this.setState({ data: data });
  };

  compare = (a, b) => {
    let aKey = a.component + (a.subComponent || '');
    aKey = aKey.toUpperCase();
    let bKey = b.component + (b.subComponent || '');
    bKey = bKey.toUpperCase();
    if (aKey > bKey) {
      return 1;
    } else if (aKey < bKey) {
      return -1;
    }
    return 0;
  };

  getCPDataSource = (component, cpDataSource, baseFactor) => {
    if ((cpDataSource == null && baseFactor == null) || cpDataSource === 'N/A') {
      cpDataSource = 'NONE';
    } else if (cpDataSource == null && Object.keys(HCP_DRIVERS_HEAD_CP_DATA).includes(baseFactor)) {
      cpDataSource = 'HEAD_CP_DATA';
    } else if (cpDataSource == null && Object.keys(HCP_DRIVERS_ACCRUED_FA_DATA).includes(baseFactor)) {
      cpDataSource = 'ACCRUED_FA_CP_DATA';
    }
    return cpDataSource
  };

  getHCPDriver = (cpDataSource, baseFactor) => {
    if (cpDataSource == null && baseFactor == null) {
      baseFactor = 'NONE';
    }
    return baseFactor;
  }

  onMappingPullSuccess = (response) => {
    let latestMappings = response.mappings;
    let stagedMappings = deepClone(this.state.stagedMappings);
    if (Array.isArray(latestMappings)) {
      latestMappings.sort(this.compare);
    } else {
      let array = [];
      for (let key in latestMappings) {
        array.push(latestMappings[key]);
      }
      array.sort(this.compare);
      latestMappings = array;
    }
    let subComponentMappings = [];
    let componentMappings = [];
    let index = 1;
    for (let mapping of stagedMappings) {
      mapping.cognosBenchmark = mapping.cognosBenchmark || [];
      mapping.accuracyBenchmark = mapping.accuracyBenchmark || [];
      mapping.cpValueMap = mapping.cpValueMap || [];
      mapping.hcpAttributeName = mapping.hcpAttributeName || "";
      mapping.phoenixAttributeName = mapping.phoenixAttributeName || "";
      mapping.cpDataSource = this.getCPDataSource(mapping.component, mapping.cpDataSource, mapping.baseFactor);
      mapping.baseFactor = this.getHCPDriver(mapping.cpDataSource, mapping.baseFactor);
      if (mapping.subComponent && mapping.subComponent !== '*' && mapping.component !== mapping.subComponent) {
        mapping.index = index++;
        subComponentMappings.push(mapping);
      } else {
        mapping.subComponent === '*' ? mapping.subComponent = mapping.component : "";
        mapping.index = 0;
        componentMappings.push(mapping);
      }
      latestMappings = latestMappings.filter((latestMapping) => {return !(
        latestMapping.component === mapping.component && (
          latestMapping.subComponent === mapping.subComponent || (
            !mapping.subComponent && latestMapping.component === latestMapping.subComponent
          )
        ));
      });
    }
    for (let mapping of latestMappings) {
      mapping.cognosBenchmark = mapping.cognosBenchmark || [];
      mapping.accuracyBenchmark = mapping.accuracyBenchmark || [];
      mapping.cpValueMap = mapping.cpValueMap || [];
      mapping.cpDataSource = this.getCPDataSource(mapping.component, mapping.cpDataSource, mapping.baseFactor);
      mapping.baseFactor = this.getHCPDriver(mapping.cpDataSource, mapping.baseFactor);
      if (mapping.subComponent && mapping.subComponent !== '*' && mapping.component !== mapping.subComponent) {
        mapping.index = index++;
        subComponentMappings.push(mapping);
      } else {
        mapping.subComponent === '*' ? mapping.subComponent = mapping.component : "";
        mapping.index = 0;
        componentMappings.push(mapping);
      }
    }
    subComponentMappings.forEach(this.flatten);
    componentMappings.forEach(this.flatten);
    this.keys = ['subComponent', 'cpValueMap', 'cpSubcomponentRollup', 'accuracyBenchmark', 'cognosBenchmark', 'cpDataSource', 'baseFactor', 'reallocationGrain', 'subcomponentRollup', 'comment', 'help'];

    this.headings = ['SubComponent', 'Flashback Columns', 'CP Rollup', 'Accuracy Benchmark', 'P&L Benchmark','HCP Driver Source', 'HCP Driver', 'Reallocation Grain', 'Benchmark Rollup', 'Comment', ''];
    this.componentHeadings = ['Component', 'CP Column', 'Subcomponent CP Rollup', 'Accuracy Benchmark', 'P&L Benchmark', 'HCP Driver Source','HCP Driver', 'Reallocation Grain', 'Subcomponent Benchmark Rollup', 'Comment', ''];

    this.setState({ subComponentMappingColumnDefinitions: this.generateColumns(this.headings, this.state.component) });
    this.setState({ componentMappingColumnDefinitions: this.generateColumns(this.componentHeadings, this.state.component) });

    let subComponentRows = [];
    let componentRows = [];
    for (let map of subComponentMappings) {
      subComponentRows.push(this.buildRow(map, this.state.subComponentMappingColumnDefinitions));
    }

    for (let map of componentMappings) {
      componentRows.push(this.buildRow(map, this.state.componentMappingColumnDefinitions));
    }

    this.setState({
      componentRows: componentRows,
      subComponentRows: subComponentRows,
      componentMappings: componentMappings,
      subComponentMappings: subComponentMappings,
    });

    let originalConfig = this.state.originalConfig || {};
    originalConfig.subComponentMappingColumnDefinitions = this.state.subComponentMappingColumnDefinitions;
    originalConfig.componentMappingColumnDefinitions = this.state.componentMappingColumnDefinitions;
    originalConfig.componentRows = deepClone(this.state.componentRows);
    originalConfig.subComponentRows = deepClone(this.state.subComponentRows);
    originalConfig.componentMappings = deepClone(this.state.componentMappings);
    originalConfig.subComponentMappings = deepClone(this.state.subComponentMappings);
    originalConfig.data = deepClone(this.state.data);

    this.setState({
      loading: false,
      error: false,
      originalConfig: originalConfig,
    });

    this.props.ignoreInProgress && !this.state.ignoreDone && this.stageIgnoredMappings();
    this.props.excludeInProgress && !this.state.excludeDone && this.stageExcludedMappings();
  };

  stageExcludedMappings = () => {
    if (this.state.componentRows.length) {
      this.prepareMappingData();
      this.removeAccuracyBenchmarkMappings(this.props.excludedAccount, deepClone(Object.values(this.state.data)));
      this.setState({excludeDone: true});
      this.onSubmitEditModal();
    }
  };

  setSelectedMappings = (mappings) => {
    let componentIndex = mappings.findIndex(entry => entry.subComponent === this.state.filters.component);
    this.setState({selectedMapping: mappings[componentIndex]});
    mappings.splice(componentIndex, 1);
    this.setState({subComponentRows: mappings});
  };

  removeAccuracyBenchmarkMappings = (account, mappings) => {
    for(let component of mappings) {
      component.accuracyBenchmark.map(v => v.value).includes(account) ?
      component.accuracyBenchmark.splice(this.fetchIndexById(component.accuracyBenchmark, account), 1) : "";
    }
    this.setSelectedMappings(mappings);
  };

  prepareMappingData = () => {
    this.setState({selectedItems: this.state.componentRows,
                    selectedMapping:this.state.data[this.state.filters.component],
                    componentMapping: this.state.data[this.state.filters.component]});
    this.originalData = this.originalData || deepClone(this.state.data);
  };

  stageIgnoredMappings = () => {
    if (this.state.componentRows.length) {
      this.prepareMappingData();
      this.removeAllMappings(this.props.ignoredAccount, deepClone(Object.values(this.state.data)));
      this.setState({ignoreDone: true});
      this.onSubmitEditModal();
    }
  };

  removeAllMappings = (account, mappings) => {
    for(let component of mappings) {
      component.cognosBenchmark.map(v => v.value).includes(account) ?
      component.cognosBenchmark.splice(this.fetchIndexById(component.cognosBenchmark, account), 1) : "";
      component.accuracyBenchmark.map(v => v.value).includes(account) ?
      component.accuracyBenchmark.splice(this.fetchIndexById(component.accuracyBenchmark, account), 1) : "";
    }
    this.setSelectedMappings(mappings);
  };

  fetchIndexById = (entries, id) => {
    return entries.findIndex(entry => entry.value === id);
  };

  buildRow = (row, columnDefinitions) => {
    let rowObj = {};
    for (let column of columnDefinitions) {
      if (typeof row[column.id] !== "undefined") {
        rowObj[column.id] = row[column.id];
      }
    }
    rowObj.component = row.component;
    return rowObj;
  };

  beginComponentEdit = () => {
    this.originalData = this.originalData || deepClone(this.state.data);
    this.setState({
      editInProgress: true,
      disableRename: true,
      selectedMapping: this.state.data[this.state.component],
      subComponentEdit: false,
    });
  };

  beginEdit = () => {
    this.originalData = this.originalData || deepClone(this.state.data);
    this.setState({ editInProgress: true, disableRename: false, subComponentEdit: true });
  };

  beginAdd = () => {
    this.originalData = this.originalData || deepClone(this.state.data);
    let newName = 'New SubComponent';
    if (!this.state.componentRows.length) {
      newName = this.state.component;
    }
    let newMapping = {
      subComponent: newName,
      component: this.state.component,
      marketplace: this.state.marketplace,
      channel: this.state.channel,
      cpValueMap: [],
      cognosBenchmark: [],
      accuracyBenchmark: [],
      version: '',
      change: Change.ADD,
    };
    let newMappings = deepClone(this.state.data);
    newMappings[newName] = newMapping;
    this.originalData[newName] = newMapping;
    this.setState({ data: newMappings, newMappingName: newName });

    this.setState({
      editInProgress: true,
      disableRename: newName === this.state.component,
      subComponentEdit: true,
      selectedMapping: this.state.data[newName],
    });
  };

  subComponentEditor = () => {
    this.editorKey = 1 + this.editorKey || 0;
    let isNewMapping = this.state.selectedMapping.change === Change.ADD;
    return (
      <MappingEditor
        key={this.editorKey}
        identity={this.props.identity}
        onCancel={this.onCancellingEditModal}
        onSubmit={this.onSubmitEditModal}
        mapping={this.state.selectedMapping}
        componentMappings={this.state.componentRows}
        subComponentMappings={this.state.subComponentRows}
        subComponentEdit={this.state.subComponentEdit}
        disableRename={(this.state.disableRenameOverride && !isNewMapping) || this.state.disableRename}
        flashbackColumns={this.state.flashbackColumns}
        oWbrCpColumn={this.state.oWbrCpColumns[this.state.component]}
        cognosConfig={this.state.cognosConfig}
        componentConfig={this.state.componentConfig}
        etlConfig={this.state.etlConfig}
        hcpAttributeName={this.state.hcpAttributeName}
        phoenixAttributeName={this.state.phoenixAttributeName}
      />
    );
  };

  handlePageClick = (selected, listKey, listItems) => {
    let offset = Math.ceil(selected * MapperPaginationSize);

    const currentDisplayLists = Object.assign({}, this.state.displayBenchmarkLists);
    currentDisplayLists[listKey] = listItems.slice(offset, offset + MapperPaginationSize);
    this.setState({displayBenchmarkLists: currentDisplayLists});
  };

  filterList = (event, key) => {
    let updatedList = Object.assign({}, this.state.benchmarkLists);
    updatedList[key] = updatedList[key].filter(function(list) {
      let key = list.props.children[0].props.children[0];
      return (
        key.length && key.toLowerCase().search(event.target.value.toLowerCase()) !== -1
      );
    });

    this.setState({filterBenchmarkLists: updatedList});
    this.handlePageClick(0, key, updatedList[key]);
  };

  getList(listKey, listItems) {
    let pageCount = 0;
    let originalCount = 0;
    if (this.state.initialDisplayList) {
      this.state.benchmarkLists[listKey] = listItems;
      this.state.filterBenchmarkLists[listKey] = listItems;
      this.state.displayBenchmarkLists[listKey] = listItems.slice(0, MapperPaginationSize);
      this.setState({initialDisplayList: false});
    }
    if (this.state.filterBenchmarkLists[listKey] && this.state.benchmarkLists[listKey]) {
      pageCount = (this.state.filterBenchmarkLists[listKey].length) / MapperPaginationSize;
      originalCount = (this.state.benchmarkLists[listKey].length) / MapperPaginationSize;
    }

    return (
      <div>
        {originalCount > 1 && <input type="text" placeholder="Filter" onChange={(event) => this.filterList(event, listKey)} />}
        <table>
          <tbody>
          {this.state.displayBenchmarkLists[listKey] && this.state.displayBenchmarkLists[listKey].map((item, index) => (<tr key={index}>{item}</tr>))}
          </tbody>
        </table>
        {pageCount > 1 && <Pagination
          pageCount={pageCount}
          onPageChange={(event) => this.handlePageClick(event.selected, listKey, listItems)}
        />}

      </div>
    );
  }

  onCancellingEditModal = (reason) => {
    if (reason === 'closeButton') {
      if(this.state.originalConfig) {
        let data = deepClone(this.state.originalConfig.data);
        delete data[this.state.newMappingName];
        this.setState({
          subComponentMappingColumnDefinitions: this.state.originalConfig.subComponentMappingColumnDefinitions,
          componentMappingColumnDefinitions: this.state.originalConfig.componentMappingColumnDefinitions,
          componentRows: deepClone(this.state.originalConfig.componentRows),
          subComponentRows: deepClone(this.state.originalConfig.subComponentRows),
          componentMappings: deepClone(this.state.originalConfig.componentMappings),
          subComponentMappings: deepClone(this.state.originalConfig.subComponentMappings),
          data: data,
        });
      }

      this.setState({
        selected: false,
        selectedItems: [],
        editInProgress: false,
        disableRename: false,
        newMappingName: "",
      });
    }
  };

  hasOriginalMapping = (mapping) => {
    return mapping.originalCPValueMap || mapping.originalAccuracyBenchmark || mapping.originalCognosBenchmark;
  };

  getOriginalMapping = (mapping) => {
    mapping = deepClone(mapping);
    if (this.hasOriginalMapping(mapping)) {
      mapping.cpValueMap = mapping.originalCPValueMap;
      mapping.accuracyBenchmark = mapping.originalAccuracyBenchmark;
      mapping.cognosBenchmark = mapping.originalCognosBenchmark;
      mapping.originalCPValueMap = undefined;
      mapping.originalAccuracyBenchmark = undefined;
      mapping.originalCognosBenchmark = undefined;
    }
    return mapping;
  };

  onDelete = () => {
    if (this.state.selectedMapping.change === Change.ADD) {
      this.unstageChange(this.state.selectedMapping);
    } else {
      this.stageChange(this.getOriginalMapping(this.state.selectedMapping), true);
    }
  };

  onRevert = () => {
    this.unstageChange(this.state.selectedMapping);
  };

  onRevertComponent = () => {
    this.unstageChange(this.state.data[this.props.component]);
  };

  onSubmitEditModal = (name, oldName) => {
    let mapping = this.state.selectedMapping;
    mapping.subComponentMappings = this.state.subComponentRows;
    if (oldName !== name) {
      let oldMapping = deepClone(mapping);
      mapping.subComponent = name;
      let data = deepClone(this.state.data);
      if (this.state.data[oldName]) {
        delete data[oldName];
        data[name] = mapping;
        for (let item in data) {
          if (item.subComponent === oldName) {
            item.subComponent = name;
            break;
          }
        }
        for (let originalItem in this.originalData) {
          if (originalItem === oldName) {
            let old = this.originalData[originalItem];
            delete this.originalData[originalItem];
            old.subComponent = name;
            this.originalData[name] = mapping;
            break;
          }
        }
      }
      this.setState({ selectedMapping: mapping, data: data });
    }
    if (mapping.change !== Change.ADD &&
      !(mapping.originalCPValueMap || mapping.originalCognosBenchmark || mapping.originalAccuracyBenchmark)) {
      this.putOriginalData(mapping);
    }
    if (!this.mappingsEqual(mapping, this.originalData[this.state.newMappingName ? this.state.newMappingName : mapping.subComponent]) || mapping.change === Change.ADD) {
      this.stageChange(mapping, false);
      this.onMappingPullSuccess({
        mappings: deepClone(this.originalData),
      });
    }
    this.setState({
      editInProgress: false,
      newMappingName: "",
    });
  };

  putOriginalData = (subComponent) => {
    subComponent.originalCPValueMap = this.originalData[subComponent.subComponent].cpValueMap;
    subComponent.originalCognosBenchmark = this.originalData[subComponent.subComponent].cognosBenchmark;
    subComponent.originalAccuracyBenchmark = this.originalData[subComponent.subComponent].accuracyBenchmark;
  };

  areSubComponentMappingsEqual = (subComponent) => {
    return this.benchmarksEqual(subComponent.cpValueMap, this.originalData[subComponent.subComponent].cpValueMap) &&
    this.benchmarksEqual(subComponent.accuracyBenchmark, this.originalData[subComponent.subComponent].accuracyBenchmark) &&
    this.benchmarksEqual(subComponent.cognosBenchmark, this.originalData[subComponent.subComponent].cognosBenchmark);
  };

  checkSubComponentMappings = (a, b) => {
    let mappingsEqual = true;
    for(let subComponent of a.subComponentMappings) {
      this.putOriginalData(subComponent);
      let equal = this.areSubComponentMappingsEqual(subComponent);
      if (equal === false) {
        this.stageChange(subComponent, false);
        this.onMappingPullSuccess({mappings: deepClone(this.originalData)});
        mappingsEqual = false;
      }
    }
    return mappingsEqual;
  };

  mappingsEqual = (a, b) => {
    if (!a) {
      return !b;
    } else if (!b) {
      return !a;
    } else {
      return this.benchmarksEqual(a.cpValueMap, b.cpValueMap) &&
        this.checkSubComponentMappings(a,b) &&
        this.benchmarksEqual(a.accuracyBenchmark, b.accuracyBenchmark) &&
        this.benchmarksEqual(a.cognosBenchmark, b.cognosBenchmark) &&
        this.benchmarkConfigurationsEqual(a, b) &&
        this.attributeNamesEqual(a, b);
    }
  };

  benchmarksEqual = (a, b) => {
    if (!(a && a.length)) {
      return !(b && b.length);
    } else if (!(b && b.length)) {
      return !(a && a.length);
    } else {
      let aItems = {};
      let bItems = {};
      for (let entry of a) {
        aItems[entry.type === 'Cognos' ? entry.value : entry.type] = entry;
      }
      for (let entry of b) {
        bItems[entry.type === 'Cognos' ? entry.value : entry.type] = entry;
      }
      for (let key of Object.keys(aItems)) {
        if (key in bItems && aItems[key].operation === bItems[key].operation && aItems[key].type === bItems[key].type && aItems[key].value === bItems[key].value) {
          delete bItems[key]
        } else {
          return false;
        }
      }
      return !Object.keys(bItems).length;
    }
  };

  benchmarkConfigurationsEqual = (a, b) => {
    return a.baseFactor === b.baseFactor && a.reallocationGrain === b.reallocationGrain &&
      a.subcomponentRollup === b.subcomponentRollup && a.cpSubcomponentRollup === b.cpSubcomponentRollup && a.cpDataSource === b.cpDataSource &&
      a.comment === b.comment;
  };

  attributeNamesEqual = (a, b) => {
    a.hcpAttributeName === b.hcpAttributeName && a.phoenixAttributeName === b.phoenixAttributeName
  }

  formatHeading = (heading, key, component) => {
    const ACCURACY_BENCHMARK_COLUMN_KEY = 'accuracyBenchmark';
    const CP_COLUMNS_COLUMN_KEY = 'cpValueMap';
    if (key === ACCURACY_BENCHMARK_COLUMN_KEY && ACCURACY_BENCHMARK_HELP_PANEL_COMPONENTS.includes(component)) {
      return <div> { heading } <InfoLink onFollow={ () => this.props.updateTools(HELP_PANEL_INFOS[component]) } /></div>;
    } else if(key === CP_COLUMNS_COLUMN_KEY && CP_COLUMN_HELP_PANEL_COMPONENTS.includes(component)
      && this.state.featureList.includes("variable-fc-help-panel")) {
      return <div> { heading } <InfoLink onFollow={ () => this.props.updateTools(HELP_PANEL_INFOS[component]) } /></div>;
    }
    return heading;
  };

  generateColumns = (headings, component) => {
    let columns = [];
    for (let [key, heading] of zip(this.keys, headings)) {
      let columnEntry = {};
      columnEntry['id'] = key;
      columnEntry['header'] = this.formatHeading(heading, key, component);
      columnEntry['cell'] = (item) => {
        let subComponentObj = this.state.data[item['subComponent']];
        if (!subComponentObj) return 'New Item';
        if (key === 'help') {
          if (subComponentObj.user) {
            return (
              <Tooltip text={`Last updated by ${subComponentObj.user}@${toDisplayDate(subComponentObj.timestamp)}`}>
                <Icon name="help" />
              </Tooltip>
            );
          }
        } else if (key === 'cpValueMap') {
          return this.getColumnDiffView(subComponentObj, item, key, false);
        } else if (key === 'cognosBenchmark') {
          return this.getColumnDiffView(subComponentObj, item, key, true);
        } else if (key === 'accuracyBenchmark') {
          return this.getColumnDiffView(subComponentObj, item, key, false);
        } else if (key === 'subComponent') {
          let output = item[key];
          if (subComponentObj.change) {
            output = Badges[subComponentObj.change](output);
          }
          return output;
        } else if (key === 'baseFactor'){
          return getBenchmarkConfigDiffView(subComponentObj, item, key);
        } else if (key === 'reallocationGrain'){
          return getBenchmarkConfigDiffView(subComponentObj, item, key);
        } else if (key === 'subcomponentRollup'){
          return getBenchmarkConfigDiffView(subComponentObj, item, key);
        } else if (key === 'cpSubcomponentRollup'){
          return getBenchmarkConfigDiffView(subComponentObj, item, key);
        } else if (key === 'comment') {
          return getBenchmarkConfigDiffView(subComponentObj, item, key);
        } else if (key === 'cpDataSource'){
          return getBenchmarkConfigDiffView(subComponentObj, item, key);
        }
        return item[key];
      };
      columnEntry['minWidth'] = '100px';
      columnEntry['allowLineWrap'] = false;
      columns.push(columnEntry);
    }
    return columns;
  };

  getColumnDiffView = (subComponentObj, item, key, hideType) => {
    let listItems = [];
    if (subComponentObj.change === Change.MODIFY) {
      let currMap = {};
      let prevMap = {};
      if (item[key]) {
        for (let elem of item[key]) {
          currMap[elem.type === "Cognos" ? elem.value : elem.type] = elem;
        }
      }
      if (subComponentObj[KeyOriginalMapping[key]]) {
        for (let elem of subComponentObj[KeyOriginalMapping[key]]) {
          prevMap[elem.type === "Cognos" ? elem.value : elem.type] = elem;
        }
        for (let prev of Object.keys(prevMap)) {
          if (prev in currMap) {
            let curr = currMap[prev];
            if (prevMap[prev].operation === currMap[prev].operation && prevMap[prev].type === currMap[prev].type && prevMap[prev].value === currMap[prev].value) {
              listItems.push(this.prepareListItem(prevMap[prev], hideType, "none"));
            } else {
              listItems.push(this.prepareListItem(currMap[prev], hideType, Change.MODIFY));
            }
            delete currMap[prev];
          } else {
            listItems.push(this.prepareListItem(prevMap[prev], hideType, Change.DELETE));
          }
        }
      }
      if (item[key]) {
        for (let curr of Object.keys(currMap)){
          listItems.push(this.prepareListItem(currMap[curr], hideType, Change.ADD));
        }
      }
    } else if (item[key]) {
      for (let i = 0; i < item[key].length; i++) {
        listItems.push(this.prepareListItem(item[key][i], hideType, subComponentObj.change === Change.DELETE ? "mappingDeleted" : "none"));
      }
    }
    let listKey = `${item.component}-${subComponentObj.subComponent ? subComponentObj.subComponent : subComponentObj.component}-${key}`;
    return this.getList(listKey, listItems);
  };

  prepareListItem = (map, hideType, change) => {
    return prepareListItem(map, hideType, change, this.cognosAccountMap, Badges);
  };

  getEmptyComponentTableUI() {
    const { error } = this.state;
    return (
      <div className="awsui-util-t-c">
        <div>{error && <b>Error loading the mappings</b>}</div>
        {!error && (
          <div>
            <div className="awsui-util-pt-s awsui-util-mb-xs">No mappings for the selected overrides and component</div>
            <div className="awsui-util-mb-m">
              {!this.state.readOnly && (
                <Button text="Add New Component Mapping" variant="primary" onClick={this.beginAdd} />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  getEmptyTableUI() {
    const { error } = this.state;
    return (
      <div className="awsui-util-t-c">
        <div>{error && <b>Error loading the mappings</b>}</div>
        {!error && (
          <div>
            <div className="awsui-util-pt-s awsui-util-mb-xs">No mappings for the selected overrides and component</div>
            <div className="awsui-util-mb-m"/>
          </div>
        )}
      </div>
    );
  }

  getHeader() {
    const { subComponentRows, selected, selectedMapping } = this.state;
    let deleted = selectedMapping.change === Change.DELETE;
    let added = selectedMapping.change === Change.ADD;
    return (
      <div className="awsui-util-action-stripe">
        <div className="awsui-util-action-stripe-title">
          <h2>
            Sub Components <span className="awsui-util-header-counter">({subComponentRows.length})</span>
          </h2>
        </div>

        <div className="awsui-util-action-stripe-group">
          <Button text="Revert" disabled={!(selected && selectedMapping.change && !added)} onClick={this.onRevert} />
          <Button text="Delete" disabled={!selected || deleted} onClick={this.onDelete} />
          <Button text="Edit" variant="primary" disabled={!selected || deleted} onClick={this.beginEdit} />
          <Button
            text="Add New Subcomponent"
            disabled={!this.state.componentRows.length}
            onClick={this.beginAdd}
          />
        </div>
      </div>
    );
  }

  getComponentHeader() {
    let change = this.state.data[this.props.component] ? this.state.data[this.props.component].change : false;
    return (
      <div className="awsui-util-action-stripe">
        <div className="awsui-util-action-stripe-group">
          {!this.state.readOnly && (
            <span>
              <Button
                text="Edit"
                variant="primary"
                disabled={!this.state.componentRows.length}
                onClick={this.beginComponentEdit}
              />
              <Button
                text="Revert"
                disabled={!change}
                onClick={this.onRevertComponent} />
            </span>
          )}
        </div>
      </div>
    );
  }

  render() {
    const {
      loading,
      subComponentRows,
      componentRows,
      componentMappingColumnDefinitions,
      subComponentMappingColumnDefinitions,
      editInProgress,
    } = this.state;

    return (
      <div>
        {!this.props.ignoreInProgress && !this.props.excludeInProgress && (
        <div className="offset-xxs-1 col-s-8 offset-l-2 col-xl-3">
          {editInProgress && this.subComponentEditor()}
          <Table
            columnDefinitions={componentMappingColumnDefinitions}
            loading={loading}
            items={componentRows}
            header={!this.state.readOnly && this.getComponentHeader()}
            empty={this.getEmptyComponentTableUI()}
            data-cy="mapper-component-table"
          />
          <br />
          <Table
            columnDefinitions={subComponentMappingColumnDefinitions}
            loading={loading}
            items={subComponentRows}
            header={!this.state.readOnly && this.getHeader()}
            empty={this.getEmptyTableUI()}
            data-cy="mapper-subcomponent-table"
          >
            {!this.state.readOnly && (
              <TableSelection
                selectionType="single"
                selectedItems={this.state.selectedItems}
                onSelectionChange={this.selectionChanged}
                trackBy="subComponent"
              />
            )}
          </Table>
        </div>)}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/mapper/mapping_table.jsx